import { MessageCircle } from "lucide-react";
import { ManualeLayout, Scheda, P, Steps, Bullets, Callout, FAQ } from "@/pages/manuali/ManualeLayout";

const A = "#4f46e5";
const SEZIONI = [
  { id: "intro", titolo: "Cos'è la Chat interna" },
  { id: "conversazioni", titolo: "Stanza staff e messaggi 1:1" },
  { id: "priorita", titolo: "Priorità dei messaggi" },
  { id: "presa", titolo: "Presa in carico" },
  { id: "escalation", titolo: "Escalation via email" },
  { id: "avvisi", titolo: "Avvisi sonori e notifiche" },
  { id: "faq", titolo: "FAQ" },
];

export default function ManualeChat() {
  return (
    <ManualeLayout titolo="Chat interna staff" sottotitolo="Comunicazioni tra colleghi Assietica" icona={MessageCircle} accent={A} sezioni={SEZIONI}>
      <Scheda id="intro" n="1" titolo="Cos'è la Chat interna" accent={A}>
        <P>La Chat interna è riservata allo <b>staff Assietica</b> (esclusi gli utenti esterni ANFFAS / Area Riservata). È sempre raggiungibile dal pulsante fluttuante in basso a destra e dalla voce <b>Chat</b> nell'header; il badge rosso indica i messaggi non letti.</P>
      </Scheda>

      <Scheda id="conversazioni" n="2" titolo="Stanza staff e messaggi 1:1" accent={A}>
        <Bullets items={[
          "Staff Assietica: stanza comune visibile a tutti i colleghi.",
          "Messaggi diretti: seleziona un collega dalla colonna di sinistra per una conversazione 1:1 privata.",
          "Il contatore a fianco di ogni conversazione mostra i messaggi non letti; il pallino rosso segnala priorità alta aperte.",
        ]} />
      </Scheda>

      <Scheda id="priorita" n="3" titolo="Priorità dei messaggi" accent={A}>
        <P>Prima di inviare puoi assegnare una priorità:</P>
        <Bullets items={[
          "Servizio (grigio): comunicazioni normali (es. ferie, circolari, promemoria).",
          "Media (giallo): richieste da gestire senza urgenza immediata.",
          "Alta (rosso): urgenze di Contabilità o Emissione polizze. Richiede la scelta dell'ambito e resta evidenziata finché non viene presa in carico.",
        ]} />
      </Scheda>

      <Scheda id="presa" n="4" titolo="Presa in carico" accent={A}>
        <Steps items={[
          "Un messaggio ad Alta priorità appare con bordo rosso e la dicitura 'Da prendere in carico'.",
          "Un collega clicca 'Prendo in carico' → il messaggio passa 'In lavorazione da …'.",
          "A lavoro concluso clicca 'Lavorata' → il messaggio viene marcato 'Lavorata da …' e non è più evidenziato.",
        ]} />
      </Scheda>

      <Scheda id="escalation" n="5" titolo="Escalation via email" accent={A}>
        <P>Quando invii un messaggio ad <b>Alta priorità</b> puoi selezionare uno o più <b>destinatari email</b> (Amministrazione, Sinistri, Agenzia, singoli colleghi).</P>
        <Callout tipo="warn">Se il messaggio <b>non viene preso in carico entro 15 minuti</b>, il sistema invia automaticamente un'email di avviso ai destinatari selezionati, così l'urgenza non passa inosservata anche se nessuno è connesso alla chat.</Callout>
      </Scheda>

      <Scheda id="avvisi" n="6" titolo="Avvisi sonori e notifiche" accent={A}>
        <P>All'arrivo di un messaggio ad Alta priorità da un collega la chat riproduce un <b>segnale acustico</b> e, se autorizzato dal browser, mostra una <b>notifica desktop</b>. Usa il pulsante <b>Avvisi attivi / off</b> in alto nella pagina per silenziarli.</P>
      </Scheda>

      <Scheda id="faq" n="7" titolo="FAQ" accent={A}>
        <FAQ items={[
          { q: "Chi può accedere alla chat?", a: "Solo lo staff interno Assietica. Gli utenti esterni ANFFAS/Area Riservata non vedono la chat." },
          { q: "L'email di escalation parte sempre?", a: "No: solo per i messaggi ad Alta priorità con destinatari selezionati e solo se non presi in carico entro 15 minuti." },
          { q: "Non sento i suoni / non vedo le notifiche", a: "Verifica che 'Avvisi' sia attivo e che il browser abbia concesso il permesso alle notifiche per il sito." },
        ]} />
      </Scheda>
    </ManualeLayout>
  );
}
